import { render, staticRenderFns } from "./CompanySuppressionModal.vue?vue&type=template&id=7db261a0&scoped=true&"
import script from "./CompanySuppressionModal.vue?vue&type=script&lang=js&"
export * from "./CompanySuppressionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db261a0",
  null
  
)

export default component.exports